import { render, staticRenderFns } from "./detailInfoBox.vue?vue&type=template&id=38f06a2a&scoped=true&"
import script from "./detailInfoBox.vue?vue&type=script&lang=ts&"
export * from "./detailInfoBox.vue?vue&type=script&lang=ts&"
import style0 from "./detailInfoBox.vue?vue&type=style&index=0&id=38f06a2a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f06a2a",
  null
  
)

export default component.exports